/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_Bank_Driver_HintInputs */

const vi_order_settlement_bank_driver_hint = /** @type {(inputs: Order_Settlement_Bank_Driver_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền vào TK của bạn: tính là bạn đang giữ, đưa lại cho kế toán như tiền mặt.`)
};

/**

* @param {Order_Settlement_Bank_Driver_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_bank_driver_hint = /** @type {((inputs?: Order_Settlement_Bank_Driver_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Bank_Driver_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_bank_driver_hint(inputs)
});